export default {
  subTitle: 'Choose how do you want to log in:',
  authenticationApp: 'Authentication App',
  SMSCode: 'SMS Code',
};
